import { PolicyApi } from "../api/PolicyApi";
import { OrganizationInfo } from "../models/api-models/organization/organization-info";

export class PolicyService {

    static async getOrganizationInfo(mnemonic: string): Promise<OrganizationInfo> {
        return  await PolicyApi.getOrganizationInfo(mnemonic)
    }
}